// extracted by mini-css-extract-plugin
export default {"cardLevelIndent":"20px","container":"TopicTreeCardDropSeparatorStack-module__container--ACmcB"};